(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('SkipperLevelHolderSearch', SkipperLevelHolderSearch);

    SkipperLevelHolderSearch.$inject = ['$resource'];

    function SkipperLevelHolderSearch($resource) {
        var resourceUrl =  'api/_search/skipper-level-holders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
